<ng-container *ngIf="isDialogVisible">
  <kendo-window [width]="900"
                [height]="850"
                [resizable]="false"
                [title]="windowTitle"
                class="app-publish-dialog top-left-counter-card k-window-content min-height-150 confirm-dialog app-confirm-dialog kendo-window-with-titlebar">
    <div class="ContentContainer projectValuationPublishPane">
      <table *ngIf="state==='start'" aria-hidden="true">
        <tr>
          <td *ngIf="mode === 'report'" class="dialogConfirmMessage" style="padding-bottom: 10px;">{{'appPublishDialog.messageReport' | translate}}</td>
          <td *ngIf="mode === 'portfolio'" class="dialogConfirmMessage" style="padding-bottom: 10px;">{{'appPublishDialog.messagePortfolio' | translate}}</td>
        </tr>
        <tr>
          <td>
            <div *ngFor="let method of publishMethods">
              <div *ngIf="(method.value != 2 && method.value != 6) || (method.value == 6 && mode == 'report')">
                <label>
                  <input type="radio" id="radioPDF" name="publishMethod" value="{{method.value}}" [(ngModel)]="activePublishMethod" [disabled]="!method.enabled" />
                  {{ method.description }}
                  <span *ngIf="method.comingSoon"><em>{{'appPublishDialog.comingSoon' | translate}}</em></span>
                </label>
              </div>
            </div>
          </td>
        </tr>
        <tr *ngIf="mode==='portfolio'">
          <td>&nbsp;</td>
        </tr>
        <tr *ngIf="mode==='portfolio'">
          <td>
            <input type="checkbox" id="merge" class="k-checkbox" [(ngModel)]="merge">
            <label class="k-checkbox-label k-checkbox-label-uppercase dialogLabel" for="merge">{{ 'appPublishDialog.merge' | translate }}</label>
          </td>
        </tr>
        <tr><td>&nbsp;</td></tr>

        <tr>
          <td class="dialogConfirmMessage" style="padding-bottom: 10px;">{{ 'appPublishDialog.qualitySettings' | translate }}</td>
        </tr>
        <tr>
          <td>
            <input type="checkbox" id="useCompression" class="k-checkbox" [(ngModel)]="settings.useCompression">
            <label class="k-checkbox-label k-checkbox-label-uppercase dialogLabel" for="useCompression">{{ 'appPublishDialog.useCompression' | translate }}</label>
          </td>
        </tr>
        <tr>
          <td class="dialogConfirmMessage" style="padding-top: 10px;">{{'appPublishDialog.imageQuality' | translate}}</td>
        </tr>
        <tr>
          <td style="padding-top: 10px;">
            <div>
              <kendo-slider class="custom-kendo-slider"
                            #balance
                            [fixedTickWidth]="10"
                            [min]="0"
                            [max]="100"
                            [smallStep]="5"
                            [largeStep]="25"
                            [(ngModel)]="settings.imageQuality">
                <kendo-slider-messages increment="Right"
                                       decrement="Left"></kendo-slider-messages>
              </kendo-slider>
              <div class="slider-number">{{ settings.imageQuality }}</div>
            </div>
          </td>
        </tr>
        <tr><td>&nbsp;</td></tr>

        <tr>
          <td class="distance">
            <input type="checkbox" id="addWatermark" class="k-checkbox" [(ngModel)]="settings.addWatermark">
            <label class="k-checkbox-label k-checkbox-label-uppercase dialogLabel" for="addWatermark">{{ 'appPublishDialog.addWatermark' | translate }}</label>
          </td>
          <td class="distance">
            <input *ngIf="settings.addWatermark" type="text" [(ngModel)]="settings.watermarkText" maxlength="20" placeholder="{{'appPublishDialog.watermarkText' | translate}}" class="fullWidth" />
          </td>
        </tr>
        <tr><td>&nbsp;</td></tr>

        <tr>
          <td colspan="2" class="distance">
            <input type="checkbox" id="passwordProtect" class="k-checkbox" [(ngModel)]="settings.passwordProtect">
            <label class="k-checkbox-label k-checkbox-label-uppercase dialogLabel" for="passwordProtect">{{ 'appPublishDialog.passwordProtect' | translate }} *</label>
          </td>
        </tr>
        <tr><td>&nbsp;</td></tr>

        <tr>
          <td colspan="2" class="distance">
            <input type="checkbox" id="coverPage" class="k-checkbox" [(ngModel)]="settings.hideCoverPage">
            <label class="k-checkbox-label k-checkbox-label-uppercase dialogLabel" for="coverPage">{{ 'appPublishDialog.coverPage' | translate }}</label>
          </td>
        </tr>
        <tr><td>&nbsp;</td></tr>

        <tr>
          <td colspan="2" class="distance">
            <input type="checkbox" id="backCoverPage" class="k-checkbox" [(ngModel)]="settings.hideBackCoverPage">
            <label class="k-checkbox-label k-checkbox-label-uppercase dialogLabel" for="backCoverPage">{{ 'appPublishDialog.backCoverPage' | translate }}</label>
          </td>
        </tr>
        <tr><td>&nbsp;</td></tr>

        <tr>
          <td colspan="2" class="distance">
            <input type="checkbox" id="hidePageNumbers" class="k-checkbox" [(ngModel)]="settings.hidePageNumbers">
            <label class="k-checkbox-label k-checkbox-label-uppercase dialogLabel" for="hidePageNumbers">{{ 'appPublishDialog.hidePageNumbers' | translate }}</label>
          </td>
        </tr>
        <tr><td>&nbsp;</td></tr>

        <tr>
          <td colspan="2" class="distance">
            <input type="checkbox" id="markAsFinal" class="k-checkbox" [(ngModel)]="settings.markAsFinal">
            <label class="k-checkbox-label k-checkbox-label-uppercase dialogLabel" for="markAsFinal">{{ 'appPublishDialog.markAsFinal' | translate }}</label>
          </td>
        </tr>
        <tr><td>&nbsp;</td></tr>

        <tr>
          <td class="dialogConfirmMessage distance" colspan="2">* {{ 'reportDesignerPrintDialog.passwordProtectHint' | translate }}</td>
        </tr>


        <tr>
          <td class="dialogConfirmMessage" style="padding-top: 10px;">{{'appPublishDialog.hint' | translate}}</td>
        </tr>

        <tr *ngIf="mode === 'portfolio'">
          <td>&nbsp;</td>
        </tr>
        <tr *ngIf="mode === 'portfolio'">
          <td class="dialogConfirmMessage" style="padding-top: 10px;">{{'appPublishDialog.mergeHint' | translate}}</td>
        </tr>
      </table>

      <table *ngIf="state==='selectProperties'" style="height: 100%;" aria-hidden="true">
        <tr>
          <td class="dialogConfirmMessage" style="padding-bottom: 10px;">{{'appPublishDialog.selectProperties' | translate}}</td>
        </tr>
        <tr>
          <td>
            <!--GRID-->
            <div>
              <kendo-grid #kendoGrid class="skip-default-content-height k-grid k-widget k-display-block k-reorderable"
                          [pageable]="true"
                          [pageSize]="gridState.take"
                          [data]="selectableReportsDataSource.data"
                          [loading]="loading"
                          [skip]="gridState.skip"
                          [sortable]="true"
                          [sort]="gridState.sort"
                          [filterable]="true"
                          [resizable]="true"
                          [selectable]="selectableSettings"
                          [filter]="gridState.filter"
                          kendoGridSelectBy="Oid"
                          [(selectedKeys)]="selectedItems"
                          [columnMenu]="columnMenuSettings"
                          [reorderable]="true">
                <kendo-grid-column *ngFor="let col of columns; trackBy: trackByField"
                                   [field]="col.field"
                                   [width]="col.width"
                                   [title]="col.title | translate"
                                   [columnMenu]="col.field !== 'checkbox'"
                                   [class]="col.field === 'PublishStatusId' ? 'publish-status-field' : ''">
                  <ng-template kendoGridHeaderTemplate *ngIf="col.field === 'checkbox'"
                               let-column
                               let-columnIndex="columnIndex">
                    <input type="checkbox" id="checkAllValuationEventProperties" [(ngModel)]="checkAllChecked" (change)="selectOrDeselectAllCheckbox()" class="k-checkbox" />
                    <label class="k-checkbox-label" for="checkAllValuationEventProperties"></label>
                  </ng-template>
                  <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" *ngIf="col.field === 'checkbox'">
                    <input type="checkbox" [(ngModel)]="dataItem.checkbox" [attr.id]="'gridCheckboxValuationEvent' + dataItem.Oid" class="gridCheckbox k-checkbox" (change)="watchIndividualCheckboxes()" /><label class="k-checkbox-label checkbox-centering" [attr.for]="'gridCheckboxValuationEvent' + dataItem.Oid"></label>
                  </ng-template>
                </kendo-grid-column>
              </kendo-grid>
            </div>
            <!--GRID-->
          </td>
        </tr>
      </table>
      <table *ngIf="state==='enqueuing'" aria-hidden="true">
        <tr>
          <td class="dialogConfirmMessage" style="padding-bottom: 10px;">{{'appPublishDialog.enqueuing' | translate}}</td>
        </tr>

      </table>
    </div>
    <div class="dialogButtonBar">
      <div class="reportDesignerButtonBarBorder">
        <div class="ButtonBar">
          <button kendoButton size="medium" class="button-confirm ButtonWidth_110px" (click)="back()" *ngIf="state==='selectProperties'">{{'appPublishDialog.back' | translate | uppercase}}</button>
          <button kendoButton size="medium" class="button-confirm ButtonWidth_110px" (click)="confirm()" *ngIf="state==='enqueued'">{{'appPublishDialog.ok' | translate | uppercase}}</button>
          <button kendoButton size="medium" class="button-confirm ButtonWidth_110px" (click)="confirm()" *ngIf="state==='start' && mode !== 'report'">{{'appPublishDialog.next' | translate | uppercase}}</button>
          <button kendoButton size="medium" class="button-confirm ButtonWidth_110px" (click)="confirm()" *ngIf="state==='start' && mode === 'report' || state==='selectProperties'">{{'appPublishDialog.ok' | translate | uppercase}}</button>
          <button kendoButton size="medium" class="button-confirm ButtonWidth_110px" (click)="cancel()" *ngIf="state==='start' || state==='selectProperties'">{{'appPublishDialog.cancel' | translate | uppercase}}</button>
        </div>
      </div>
    </div>
  </kendo-window>
  <div class="k-overlay"></div>
</ng-container>

